<template>
  <div class="product-viewer-v2">
    <div v-show="!showVTO">
      <template v-if="smallScreen">
        <slider
          :previous-panel-text="previousPanelText"
          :next-panel-text="nextPanelText"
          :per-page="1"
          :start-at="activeItem"
          :navigation-enabled="true"
          :pagination-enabled="false"
          :is-pagination-clickable="false"
          :tagging-labels="taggingLabels"
          ref="slider"
          @pageChange="whenPageChange"
        >
          <slide v-for="(item, index) in productPackshots" :key="index">
            <div class="product-viewer__img variant-image">
              <img :src="item['0']" :alt="item['alt']">
              <noscript>
                <!-- SEO-->
                <img :src="item['0']" :alt="item['alt']" class="product-card__img">
              </noscript>
            </div>
          </slide>
        </slider>
      </template>
      <template v-else>
        <div class="product-viewer__wrapper">

          <div class="product-viewer__previews">
            <slider
              :previous-panel-text="previousPanelText"
              :next-panel-text="nextPanelText"
              :per-page="1"
              :scroll-per-page="true"
              :start-at="activeItem"
              :navigation-enabled="true"
              :pagination-enabled="false"
              :swipe-on-desktop="false"
              ref="slider"
              @pageChange="whenPageChange"
            >
              <slide v-for="(item, index) in productPackshots" :key="index">
                <div class="product-viewer__img variant-image">
                  <img :src="item['1024']" :alt="item['alt']">
                  <noscript>
                    <!-- SEO-->
                    <img :src="item['1024']" :alt="item['alt']" class="product-card__img">
                  </noscript>
                </div>
              </slide>
            </slider>
          </div>
        </div>
      </template>
    </div>
    <div class="product-viewer__previews" v-if="productDetails && productDetails.isProductModifaceEnabled === true">
      <h3 class="product-viewer__previews__title"><strong>{{ dataTextTitle }} </strong></h3>
      <div class="product-viewer__previews__description"> {{ dataTextDescription }}</div>
    </div>
    <virtual-tryon
      :modiface-settings="modifaceSettings"
      :product-details="productDetails"
      :product-category="productCategory"
      :upc-list="upc"
      :colors-list="colorList"
      :live-camera-text="liveCameraText"
      :upload-image-text="uploadImageText"/>
  </div>
</template>

<script>
  import Slide from '@Feature/Slider/code/Scripts/components/slide/slide';
  import Slider from '@Feature/Slider/code/Scripts/components/slider/slider';
  import virtualTryon from '@Feature/VTO/Code/Scripts/components/virtual-tryon';
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';

  export default {
    name: 'product-viewer-v2',
    components: {
      Slide,
      Slider,
      virtualTryon,
    },
    props: {
      modifaceSettings: { type: Object, required: false },
      productDetails: { type: Object, required: false, default: { isProductModifaceEnabled: true } },
      productCategory: { type: String, required: false },
      upcList: { type: Array, required: false },
      liveCameraText: { type: String, required: false },
      uploadImageText: { type: String, required: false },
      colorsList: { type: Array, required: false },
      dataTextTitle: { type: String, required: false },
      dataTextDescription: { type: String, required: false },
      taggingLabels: { type: Object, require: false, default: null },
      nextPanelText: { type: String, required: false, default: 'next panel' },
      previousPanelText: { type: String, required: false, default: 'previous panel' },
      productPackshots: { type: Array, required: false, default: [{
                                                                    '0': 'http://res.cloudinary.com/wsf/image/upload/f_auto,q_auto/v1524648556/Photo_1_MobileSquare.png',
                                                                    '360': 'http://res.cloudinary.com/wsf/image/upload/f_auto,q_auto/v1524648530/Photo_1_MobileBig.png',
                                                                    '700': 'http://res.cloudinary.com/wsf/image/upload/f_auto,q_auto,c_scale,h_750/v1524648571/Photo_1_MobileBig.png',
                                                                    '1024': 'http://res.cloudinary.com/wsf/image/upload/f_auto,q_auto/v1524648571/Photo_1_big.png'
                                                                  },
                                                                  {
                                                                    '0': 'http://res.cloudinary.com/wsf/image/upload/f_auto,q_auto/v1524648556/Photo_1_MobileSquare.png',
                                                                    '360': 'http://res.cloudinary.com/wsf/image/upload/f_auto,q_auto/v1524648530/Photo_1_MobileBig.png',
                                                                    '700': 'http://res.cloudinary.com/wsf/image/upload/f_auto,q_auto,c_scale,h_750/v1524648571/Photo_1_MobileBig.png',
                                                                    '1024': 'https://www.laroche-posay.be/-/media/project/loreal/brand-sites/lrp/emea/be/products/lipikar/lipikar-baume-ap-plus-m/larocheposaybodycarelipikarbaumeapl400mllipidreplenishingbalmantiirritation3337872418570front.png'
                                                                  },
                                                                  {
                                                                    '0': 'http://res.cloudinary.com/wsf/image/upload/f_auto,q_auto/v1524648556/Photo_1_MobileSquare.png',
                                                                    '360': 'http://res.cloudinary.com/wsf/image/upload/f_auto,q_auto/v1524648530/Photo_1_MobileBig.png',
                                                                    '700': 'http://res.cloudinary.com/wsf/image/upload/f_auto,q_auto,c_scale,h_750/v1524648571/Photo_1_MobileBig.png',
                                                                    '1024': 'https://www.laroche-posay.be/-/media/project/loreal/brand-sites/lrp/emea/be/products/lipikar/lipikar-baume-ap-plus-m/larocheposaybodycarelipikarbaumeap400mlzoomedfrontsoftshadow.jpg'
                                                                  }] },
      productId: { type: String, required: false, default: ''},
      productEan: { type: String, required: false, default: ''},
    },

    data() {
      return {
        activeItem: 0,
        smallScreen: !window.matchMedia('(min-width: 1024px)').matches,
        colorList: this.colorsList,
        upc: this.upcList,
        showVTO: false,
      };
    },
    computed: {
      getVTO() {
        return this.$store.getters.getVTO;
      },
    },
    mounted() {
      window.eventBus.$on('checkTryiton',() => {
        setTimeout(() => {
          this.showVTO = true;
        }, 300);
      });
      window.eventBus.$on('hideVTO',() => {
        setTimeout(() => {
          window.eventBus.$emit('showVTO', false);
          this.showVTO = false;
        }, 300);
      });
      window.eventBus.$on('showPDP',(data) => {
        setTimeout(() => {
          this.showVTO = data;
        }, 300);
      });
    },
    methods: {
      whenPageChange(currentPage, prevPage, actionType) {
        document.dispatchEvent(new CustomEvent('carouselLazyImg'));
        AnalyticsHandler.pushDataLayer({
          'event': 'uaevent',
          'event_name': 'product_viewer',
          'ecommerce': 'undefined',
          'eventCategory': 'product detail page',
          'eventAction': `select::${currentPage > prevPage ? 'next' : 'previous'}`,
          'eventLabel': `${currentPage + 1}::${this.taggingLabels.label[currentPage].toLowerCase()}`,
          'click_action': `select::${currentPage > prevPage ? 'next' : 'previous'}`,
          'product_info': `${this.productDetails.prodName.toLowerCase()}::${this.productEan}`
        });
      },
    }
  };
</script>

<style lang="scss" src="./product-viewer-v2.scss"></style>
